import { StoryModel } from '../models/story.model';
import { ContentType } from '../models/content-type.enum';
import { StoryChunkLoadModel } from './story.state.model';
import { defaultLocale } from 'src/app/locale-config.module';
import { TweenParticleLookupModel } from '../models/tween-particle-lookup.model';

export class LoadStory {
  static readonly type = '[Story] Load Current Story';
  constructor(
    public id: string,
    public type: ContentType,
    public lang = defaultLocale.lang,
    public preview = false,
  ) {}
}

export class AddToStory {
  static readonly type = '[Story] Add to current story';
  constructor(public id: string, public type: ContentType) {}
}

export class SetStory {
  static readonly type = '[Story] Replace the Story';
  constructor(public story: StoryModel) {}
}

export class SetStoryId {
  static readonly type = '[Story] Set the Story ID';
  constructor(public id: string) {}
}

export class SetStoryText {
  static readonly type = '[Story] Set Story Text';
  constructor(public displayName: string) {}
}

export class SetStoryTags {
  static readonly type = '[Story] Set Story Tags';
  constructor(public tags: string[]) {}
}

export class SetIncomingStory {
  static readonly type = '[Story] Set Incoming Story Id';
  constructor(public id: string, public type: ContentType, public reset?: boolean) {}
}

export class LoadStoryChunk {
  static readonly type = '[Story] Load Story Chunk';
  constructor() {}
}

export class ReorderLoadChunks {
  static readonly type = '[Story] Reorder Load Chunks';
  constructor(public chapterId: string) {}
}

export class LoadStoryChunkSuccess {
  static readonly type = '[Story] Load Story Chunk Success';
  constructor(public chunk: StoryChunkLoadModel) {}
}

export class BuildStory {
  static readonly type = '[Story] Build Story In Engine From Story Model';
  constructor(
    public id: string,
    public story: StoryModel,
    public type: ContentType,
    public chapterIdx?: number,
  ) {}
}

export class LoadStorySuccess {
  static readonly type = '[Story] Load Success';
  constructor(public story: StoryModel, public id: string, public type: ContentType) {}
}

export class LoadStoryFail {
  static readonly type = '[Story] Load Fail';
  constructor(public id: string, public type: ContentType) {}
}

export class ImportStory {
  static readonly type = '[Story] Import';
  constructor(public id: string, public type: ContentType, public lang = defaultLocale.lang) {}
}

export class ImportStorySuccess {
  static readonly type = '[Story] Import Success';
  constructor(public story: StoryModel, public id: string, public type: ContentType) {}
}

export class ResetStory {
  static readonly type = '[Story] Clear';
  constructor() {}
}

export class SynchronizeChapters {
  static readonly type = '[Story] Synchronize Chapters';
  constructor() {}
}

export class HumanReadyWeb {
  static readonly type = '[Story] Human Ready (Web)';
  constructor() {}
}

export class HumanReadySDK {
  static readonly type = '[Story] Human Ready (SDK)';
  constructor() {}
}

export class MergeBridgeModuleSuccess {
  static readonly type = '[Story] Merge Bridge Module Success';
  constructor(public story: StoryModel) {}
}
